const MiniTextareaEditor = {
  props: ['value', 'width', 'height'],
  model: { event: 'change' },
  computed: {
    styles () {
      let ret = { height: '46px', paddingTop: '5px', paddingBottom: '5px' };
      if (this.width) ret.width = this.width + 'px';
      if (this.height) ret.height = this.height + 'px';
      return ret;
    }
  },
  methods: {
    onChange (e) { this.$emit('change', e.target.value); }
  },
  render (h) {
    return h('textarea', {
      domProps: { value: this.value },
      class: 'r-mini-editor',
      style: this.styles,
      on: {
        change: this.onChange
      }
    })
  }
}

export default {
  install: function (Vue) {
    Vue.component('mini-textarea-editor', MiniTextareaEditor)
  }
}